module.exports = __webpack_public_path__ + "static/mulher-cff796e71fa211f8d34876775435bc26.png";